exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".barestho-toast-notification {\n    text-align: center;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/components/ToastNotification/ToastNotification.css
// module id = 1350
// module chunks = 38